import cookie from 'js-cookie';
import { isProduction } from '~/stage';

const baseOptions: Cookies.CookieAttributes = isProduction()
  ? {
      domain: 'followathletics.com',
      expires: 30,
    }
  : {
      domain: 'localhost',
      expires: 365,
    };

export const cookies = {
  get: cookie.get,

  set: (name: string, value: string, options?: Cookies.CookieAttributes) => {
    return cookie.set(name, value, {
      ...baseOptions,
      ...options,
    });
  },

  remove: (name: string, options?: Cookies.CookieAttributes) => {
    return cookie.remove(name, {
      ...baseOptions,
      ...options,
    });
  },
};
